import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { queryClient } from "@/lib/queryClient";

import { DisplayTimeZoneSync } from "./components/DisplayTimeZoneSync";
import { routes } from "./routes";

const router = createBrowserRouter(routes);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DisplayTimeZoneSync />
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}